import Cookie from '@modules/cookie';

/*
 * See operations/registration-or-sign-in/scripts/JScript_register.js -> check_And_Register
 */
export const SignUpResult = {
    ERROR_BANNED: 5,
    ERROR_UNKNOWN: 0,
    ERROR_VALIDATION: 2,
    REGISTERED_AND_ACTIVATED: 3,
    SUCCESS: 1
} as const;

const getInputValue = (name: string): string =>
    document.querySelector(`input[name="${name}"]`)?.getAttribute('value') ?? '';

const getClickId = (cookieKey: string, urlParam: string): string => {
    const cookieValue = Cookie.get(cookieKey);
    if (cookieValue) return cookieValue;

    const urlValue = new URLSearchParams(window.location.search).get(urlParam);
    return urlValue ?? '';
};

export async function signUp(
    firstName: string,
    lastName: string,
    email: string,
    password: string,
    company: string,
    jobTitle: string,
    country: string,
    questionnaireAnswers: string[],
    howDidYouHearAboutUs?: string,
    howDidYouHearAboutUsOther?: string
): Promise<number> {
    try {
        const response = await fetch('/operations/registration-or-sign-in/AJAX-REQUESTS-Registration.asmx/Register', {
            body: JSON.stringify({
                Marketing: {
                    Google_Click_ID: getClickId('_gcl_aw', 'gclid'),
                    How_Did_You_Hear_About_Us: howDidYouHearAboutUs,
                    How_Did_You_Hear_About_Us_Other: howDidYouHearAboutUsOther,
                    Microsoft_Click_ID: getClickId('_msclkid', 'msclkid'),
                    Page_Title: document.title,
                    Page_Url: window.location.host + window.location.pathname,
                    QuestionnaireAnswers: questionnaireAnswers,
                    Utk_Token: Cookie.get('hubspotutk'),
                    Utm_Campaign: getInputValue('utm_campaign'),
                    Utm_Content: getInputValue('utm_content'),
                    Utm_Medium: getInputValue('utm_medium'),
                    Utm_Source: getInputValue('utm_source'),
                    Utm_Term: getInputValue('utm_term')
                },
                Registration_Details: {
                    Company: company,
                    Country: country,
                    Email: email,
                    F_Name: firstName,
                    Profession: jobTitle,
                    S_Name: lastName,
                    Unencrypted_Password: password
                }
            }),
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST'
        });

        const body = await response.json();
        return parseInt(body.d.charAt(0));
    } catch (error) {
        console.error(error);
    }

    return SignUpResult.ERROR_UNKNOWN;
}
